import { type AssortmentTemplateImportErrorCode } from '../../../redux/assortment';
import { type AssortmentTranslationFunction } from '../../../types/translations';
type AssortmentTranslationKey = Parameters<AssortmentTranslationFunction>[0];

export const importErrorCodeToMessageTranslationKeyMap: Record<
  AssortmentTemplateImportErrorCode,
  AssortmentTranslationKey
> = {
  NO_EXCEL_DATA: 'upload-template-modal.upload-error.no-excel-data',
  INVALID_FILE__WRONG_AGGREGATION_TYPE:
    'upload-template-modal.upload-error.invalid-file-wrong-aggregation-type',
  INVALID_FILE__MISSING_COLUMN:
    'upload-template-modal.upload-error.invalid-file-missing-column',
  INVALID_FILE__REQUIRED_COLUMN_IS_NON_STRING:
    'upload-template-modal.upload-error.invalid-file-required-column-is-non-string',
  INVALID_FILE__REQUIRED_COLUMN_CONTAINS_NULL:
    'upload-template-modal.upload-error.invalid-file-required-column-contains-null',
  INVALID_FILE__REQUIRED_COLUMN_CONTAINS_EMPTY_STRING:
    'upload-template-modal.upload-error.invalid-file-required-column-contains-empty-string',
  INVALID_FILE__INVALID_USER_SET_ASSORTED_VALUE:
    'upload-template-modal.upload-error.invalid-file-invalid-user-set-assorted-value',
  INVALID_FILE__INVALID_DATE:
    'upload-template-modal.upload-error.invalid-file-invalid-date',
  INVALID_FILE__DATE_SET_BUT_NOT_ASSORTED:
    'upload-template-modal.upload-error.invalid-file-date-set-but-not-assorted',
  INVALID_FILE__START_DATE_AFTER_END_DATE:
    'upload-template-modal.upload-error.invalid-file-start-date-after-end-date',
  INVALID_FILE__IA_SET_BUT_ASSORTED_IS_NULL:
    'upload-template-modal.upload-error.invalid-file-ia-set-but-assorted-is-null',
  INVALID_FILE__IA_ARE_NOT_INTEGERS:
    'upload-template-modal.upload-error.invalid-file-ia-are-not-integers',
  INVALID_FILE__ASSORTMENT_COLUMNS_BUT_USING_DATA_FEED_FOR_ASSORTMENT:
    'upload-template-modal.upload-error.invalid-file-assortment-columns-but-using-data-feed-for-assortment',
  USING_DATA_FEED: 'upload-template-modal.upload-error.using-data-feed',
  UNKNOWN_ERROR: 'upload-template-modal.upload-error.unknown-error',
};
